import styled from 'styled-components';
import theme from '../theme';

export const TooltipWrapper = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radii.md};
  box-shadow: ${theme.shadows.lg};
  padding: ${theme.spacing.lg};
  max-width: 380px;
  min-width: 300px;
  font-family: ${theme.typography.fontFamily};
  position: relative;
`;

export const TooltipHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.sm};
`;

export const TooltipTitle = styled.h3`
  font-size: ${theme.typography.h3.size};
  font-weight: ${theme.typography.h3.weight};
  color: ${theme.colors.text};
  margin: 0;
`;

export const StepCounter = styled.span`
  font-size: ${theme.typography.small.size};
  color: ${theme.colors.textSecondary};
  white-space: nowrap;
`;

export const TooltipContent = styled.p`
  font-size: ${theme.typography.body.size};
  line-height: ${theme.typography.body.lineHeight};
  color: ${theme.colors.textSecondary};
  margin: 0 0 ${theme.spacing.lg} 0;
`;

export const TooltipFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.sm};
`;

export const SkipButton = styled.button`
  background: none;
  border: none;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.small.size};
  color: ${theme.colors.textMuted};
  cursor: pointer;
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border-radius: ${theme.radii.sm};
  transition: color ${theme.transitions.fast};

  &:hover {
    color: ${theme.colors.textSecondary};
  }
`;

export const NavButtons = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
`;

export const BackButton = styled.button`
  background: ${theme.colors.background};
  border: 1px solid ${theme.colors.border};
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.body.size};
  font-weight: 500;
  color: ${theme.colors.textSecondary};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.radii.sm};
  cursor: pointer;
  transition: all ${theme.transitions.fast};

  &:hover {
    background: ${theme.colors.surfaceHover};
    color: ${theme.colors.text};
  }
`;

export const NextButton = styled.button`
  background: ${({ $isLast }) => $isLast ? theme.colors.success : theme.colors.primary};
  border: none;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.body.size};
  font-weight: 600;
  color: #ffffff;
  padding: ${theme.spacing.sm} ${theme.spacing.lg};
  border-radius: ${theme.radii.sm};
  cursor: pointer;
  transition: background ${theme.transitions.fast};

  &:hover {
    background: ${({ $isLast }) => $isLast ? '#0ea271' : theme.colors.primaryLight};
  }
`;
